import { render, staticRenderFns } from "./bgmap.vue?vue&type=template&id=2eb6a8c7&scoped=true&"
import script from "./bgmap.vue?vue&type=script&lang=js&"
export * from "./bgmap.vue?vue&type=script&lang=js&"
import style0 from "./bgmap.vue?vue&type=style&index=0&id=2eb6a8c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb6a8c7",
  null
  
)

export default component.exports